var fair = {
    search: function(){

        $('body').prepend('<div class="rebuy_fileter_bg"></div>');

        $('.rebuy-smart-search-results-page-sidebar__context-right').append('<div class="Filter_Sort">Filter & Sort</div>');

        $('body').on('click', '.Filter_Sort', function(){
            $('.rebuy-smart-search-results-page__filter-section').addClass('active');
            $('.rebuy_fileter_bg').addClass('active');
        });

         $('body').on('click', '.rebuy_fileter_bg', function(){
            $('.rebuy-smart-search-results-page__filter-section').removeClass('active');
            $(this).removeClass('active');
        });
    },
     Embroidery: function(){

        var g_color ='White'; g_text = '';

        $('.adpt_bg, .adpt_close').on('click', function(){
            $('.adpt_seciton').removeClass('active');
        });

        $('.adpt_addtocart').on('click', function(){
            setTimeout(function(){
                $('.adpt_seciton').removeClass('active');
            }, 2000);            
        });

         $('body').on('click', function(){
            $('.addon_form_option').removeClass('active');
         });
        

        $('.addon_style').on('click', function(){
            $('.adpt_seciton').addClass('active');

            
            var id = $('select[name="id"]').val();
            $('.product_addon_id').val(id);
            /*
            $('.spb-productoptiontextcolor').prop('checked', true);
            var price = $('.spb-productoptiontextcolor').val();
            console.log(price);
            $('#infiniteoptions-container [name="properties[monogram fee]"]').val(price);
            */
        });

        $('#infiniteoptions-container').on('click', function(){
            setTimeout(function(){
                if($('.spb-productoptiontextcolor').is(':checked')){
                    $('.adpt_seciton').addClass('active');   
                    var id = $('select[name="id"]').val();
                    $('.product_addon_id').val(id);
                    
                    // add custom code
                    //$('.adpt_addtocart').prop('disabled', false);
                    var value = $('.type_icon_txt[name="type"]:checked').val();
                    Embroidery_select(value);
                    console.log(value);
                }
            }, 20);
             
             
        });
        $('.type_icon_txt[name="type"]').on('change', function(){  
             var value =$(this).val(); 
             Embroidery_select(value);
        });

        function Embroidery_select(value){
            $('.adpt_active_box').removeClass('active');
             $('.adpt_active_box[data-value="'+value+'"]').addClass('active');

             $('.adptli__icon, .adpttxt_txt_value').attr('name', 'null');

             // uncheck 
              
             if(value == 'icon'){
                var img = $('.adptli__icon:checked').data('img');  
                var img_val = $('.adptli__icon:checked').val();

                if(typeof img !== 'undefined'){
                    //$('.adptpd_value').html('<img src="'+img+'">');

                    $('.adpt_style_href').addClass('active');
                    $('.adpt_addtocart').prop('disabled', false);
                    text_value(img_val);
                }else{
                    $('.adpt_style_href').removeClass('active');
                    $('.adpt_addtocart').prop('disabled', true); 
                }

                // remove color 
                color_value('');
                $('.adpt_listing_color').addClass('active');

             }else{
                var text = $('.adpttxt_txt_value').val(); 
                //$('.adptpd_value').html(text);

                //$('.adpttxt_txt_value').attr('name', 'properties[Text]');

               
                text_value(text);
                 if($('.adpttxt_txt_value').val() == ''){
                    $('.adpt_style_href').removeClass('active');
                    $('.adpt_addtocart').prop('disabled', true);
                    
                 }else{
                    $('.adpt_style_href').addClass('active');
                    $('.adpt_addtocart').prop('disabled', false);
                 }

                 // add color 
                 var color = $('.dptli_txt_color[name="Color"]:checked').val();
                 color_value(color);
                 $('.adpt_listing_color').removeClass('active');
             }
        }



        $('.dptli_txt_color').on('change', function(){ 
            var color = $(this).data('val'); 
            //$('.adptpd_value').css('color', color);
            $('.adptls_color_value').html($(this).val());

            color_value($(this).val());

        });
        $('.adptli__icon').on('change', function(){ 
            var img = $(this).data('img');
            if(img !== ''){
                //$('.adptpd_value').html('<img src="'+img+'">');
                text_value($(this).val());
            }
            
            

        }); 

        $('.adpttxt_txt_value').on('input', function(){ 
            
            $(this).val($(this).val().replace(/[^a-zA-Z]/g, '').toUpperCase());
            var value= $(this).val(); 

            if (value.length > 3) {
                value = value.slice(0, 3);
                $(this).val(value);   
                
            }else{
                $('.adpttxt_display, .adptpd_value').html(value); 
            }

             text_value(value);

            if(value == ''){
                $('.adpttxt_display').html('ABC');
                $('.adptpd_value').html('');

                $('.adpt_style_href').removeClass('active');
                $('.adpt_addtocart').prop('disabled', true);
            }else{
                $('.adpt_style_href').addClass('active');
                $('.adpt_addtocart').prop('disabled', false);
            } 
        });

        $('.next_prev').on('click', function(){
            var id = $(this).data('id'); 

            if(id == 2){
                if(!$('.type_icon_txt[name="type"]').is(':checked')){
                    return; 
                }
            }  

            $('.adpt_step').removeClass('active');
            $('.adpt_step[data-id="'+id+'"]').addClass('active');
        });

        $('.adpt_style_href').on('click', function(){
                if($(this).hasClass('active')){  }
                    $('.adpt_step').removeClass('active');
                    $('.adpt_step[data-id="2"]').addClass('active');
                               
        });


        function color_value(text){
            g_color = text;            
            $('[name="properties[Color]"]').val(text).trigger('change').trigger('input');
            hide_value();
        }
        function text_value(text){
            g_text = text;
            $('[name="properties[Text]"]').val(text).trigger('change').trigger('input');
            hide_value();
        }
        function hide_value(){
            var text = '{"Text":"'+g_text+'","Color":"'+g_color+'", "Monogram Fee":"13"}';
            $('[name="properties[_io_properties]"]').val(text).trigger('change').trigger('input');
            
        }

    },
    menu: function(){
        $('.menu_btn_submenu').on('click', function(){
            $(this).toggleClass('active');
            $(this).next('.hide_menu_submenu').slideToggle();
        });

    },
    Product: function(){

        $('.product-card__link').on('click', function(e){
                if($(window).width() < 768){                     
                    e.preventDefault(); 
                    var href = $(this).attr('href');
                     //console.log('gaurav');
                    // window.location.href = href;
                    url_redirec(href); 
                } 
            });

            function url_redirec(url){
                setTimeout(function(){                
                        window.location.href = url;
                }, 1000)
            }
            
        var checkSwiper = setInterval(function() {
            if (document.querySelector('.js-product-swiper-container-pdp')) {
            clearInterval(checkSwiper);

            // Access the Swiper instance
            var productSwiper = document.querySelector('.js-product-swiper-container-pdp').swiper;

            // Next button
            $('.btn-next').on('click', function() {
                if (productSwiper) productSwiper.slideNext();
            });

            // Prev button
            $('.btn-prev').on('click', function() {
                if (productSwiper) productSwiper.slidePrev();
            });
            }
        }, 300);
    },
    variant_option: function(){
        $('.js-hero-product-option-group-value').on('change', function(){
               // var titleToFind = $('.js-hero-product-variant-select-element[name="id"] option:selected').data('title');
                var pd_id = $(this).closest('.block_variant').attr('data-default_variant');
                //check_soldOut(pd_id, 1); 
                fair.check_available_variant(pd_id, 1);  
        });
        $('body').on('change', '.js-quick-add-product-option-group-value', function() {            
            
               var pd_id = $(this).closest('.block_variant').attr('data-default_variant');
                // check_soldOut(pd_id, 0); 
              //  fair.check_available_variant(pd_id, 0);
          //  check_soldOut(titleToFind);   
        });

        if($('body').hasClass('template-product')){
            fair.check_available_variant($('.block_variant').attr('data-default_variant'), 1);  
        }
        
        //check_soldOut();

        function check_soldOut(pd_id, type){

            //var titleToFind = $(this).val(); 
            var result = [];
            $('.rounde_custome_outer').addClass('out-of-stock');  

            //console.log(grouped_product);  

            // var titleToFind = $('.js-hero-product-variant-select-element[name="id"] option:selected').data('title');
            if(type){
                 var titleToFind = $('.block_variant[data-default_variant='+pd_id+'] .js-hero-product-variant-select-element[name="id"] option:selected').data('title');
            }else{
                 var titleToFind = $('.block_variant[data-default_variant='+pd_id+'] .js-quick-add-product-variant-select-element[name="id"] option:selected').data('title');
                 
                 var shref = $('.block_variant[data-default_variant='+pd_id+'] .sdp_href').attr('data-handle');
                 //console.log(shref);
                 if(typeof shref !== "undefined"){
                    shref += '?variant=' + $('.block_variant[data-default_variant='+pd_id+'] .js-quick-add-product-variant-select-element[name="id"]').val()+'&side_true';
                    $('.block_variant[data-default_variant='+pd_id+'] .sdp_href').attr('href', shref);
                 }
            }  
           

            if(titleToFind){
                $.each(grouped_product, function(i, product) {
                    $.each(product.g_variant, function(j, variant) {
                        if (variant.title.toLowerCase() === titleToFind.toLowerCase()) {
                        result.push({
                            product_id: product.product_id,
                            available: variant.available,
                            variant_id: variant.id
                        });
                        }
                    });
                });       
 
                $.each(result, function(i, item){
                    if(item.available){
                        $('.rounde_custome_outer[data-product_id="'+item.product_id+'"]').removeClass('out-of-stock');                        
                    }
                        var href = $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href');
                       // console.log(href);
                        if(typeof href !== "undefined"){
                             var newHref = href.replace(/variant=\d+/, 'variant='+item.variant_id);
                             $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href', newHref);
                        }
                        
                });
            } 
        }

    },
    check_available_variant: function(pd_id, type){
         //var titleToFind = $(this).val(); 
            var result = [];
            $('.rounde_custome_outer').addClass('out-of-stock');  

            //console.log(grouped_product);  

            // var titleToFind = $('.js-hero-product-variant-select-element[name="id"] option:selected').data('title');
            if(type){
                 var titleToFind = $('.block_variant[data-default_variant='+pd_id+'] .js-hero-product-variant-select-element[name="id"] option:selected').data('title');
            }else{
                 var titleToFind = $('.block_variant[data-default_variant='+pd_id+'] .js-quick-add-product-variant-select-element[name="id"] option:selected').data('title');
               
                 var shref = $('.block_variant[data-default_variant='+pd_id+'] .sdp_href').attr('data-handle');
                 //console.log(shref);
                 if(typeof shref !== "undefined"){
                    shref += '?variant=' + $('.block_variant[data-default_variant='+pd_id+'] .js-quick-add-product-variant-select-element[name="id"]').val()+'&side_true';
                    $('.block_variant[data-default_variant='+pd_id+'] .sdp_href').attr('href', shref);
                 }
            }  
              console.log(titleToFind);

              if(typeof titleToFind === "undefined"){
                 titleToFind = $('.block_variant[data-default_variant='+pd_id+'] .js-quick-add-product-variant-select-element[name="id"] option:nth-child(2)').data('title');
              }

            if(titleToFind){
                const title = String(titleToFind).toLowerCase();
                $.each(grouped_product, function(i, product) {
                    $.each(product.g_variant, function(j, variant) {
                        if (variant.title.toLowerCase() === title) {
                        result.push({
                            product_id: product.product_id,
                            available: variant.available,
                            variant_id: variant.id
                        });
                        }
                    });
                });       
 
                $.each(result, function(i, item){
                    if(item.available){
                        $('.rounde_custome_outer[data-product_id="'+item.product_id+'"]').removeClass('out-of-stock');                        
                    }
                        var href = $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href');
                        console.log(href);
                        if(typeof href !== "undefined"){
                             var newHref = href.replace(/variant=\d+/, 'variant='+item.variant_id);
                             $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href', newHref);
                        }
                        
                });
            } 
    },
        gift: function(){

            $(".gift_addtocart").on("click", function () {
                // Get variant ID dynamically
                var product_id = $('select[name="id"]').val();
 
                // Read all form field values
                var recipientId    = $("#givy_recipient_id").val();
                var sendMethod     = $("#givy_send_method").val();
                var recipient      = $("#givy_recipient").val();
                var recipientName  = $("#givy_recipient_name").val();
                var recipientEmail = $("#givy_recipient_email").val();
                var gifterName     = $("#givy_gifter_name").val();
                var message        = $("#givy_message").val();
                var gifUrl         = $("#givy_gif_url").val();
                var marketState    = $("#givy_market_state").val();

                var payload = {
                    id         : product_id,
                    quantity   : 1,
                    properties : {
                    "_givy_recipient_id"   : recipientId,
                    "_givy_send_method"    : sendMethod,
                    "Recipient"            : recipient,
                    "_givy_recipient_name" : recipient,
                    "_givy_recipient_email": recipientEmail,
                    "_givy_gifter_name"    : gifterName,
                    "_givy_message"        : message,
                    "_givy_gif_url"        : gifUrl,
                    "_givy_data"           : JSON.stringify({ "_givy_market_state": marketState })
                    }
                };

                $.ajax({
                    url        : "/cart/add.js",
                    type       : "POST",
                    contentType: "application/json",
                    dataType   : "json",
                    headers    : { "X-Requested-With": "XMLHttpRequest" },
                    data       : JSON.stringify(payload),
                    success    : function (response) {
                    console.log("Gift added to cart!");
                    },
                    error      : function (xhr) {
                    var msg = xhr.responseJSON ? xhr.responseJSON.description : "Unknown error";
                    console.log("Error: " + msg);
                    }
                });

            });

            $('.gift_send_checkbox').on('change', function () {
                $('.givy-gift-form').slideToggle();
                $('.jshproduct_box').slideToggle();
                /*
                    if ($(this).is(':checked')) {
                        console.log('Checkbox Checked'); 
                    } else {
                        console.log('Checkbox Unchecked'); 
                    }
                */
            });
        }
}
$(function() {
    setTimeout(() => {
        // fair.search();
    }, 5900);

    fair.Embroidery();
    fair.menu();

    fair.Product();

    fair.variant_option();

     fair.gift();

    $('.js-add-to-bag-cta').hide();
    setTimeout(function(){
        $('.js-add-to-bag-cta').css('display', 'flex');
    }, 3000);
})